export const en = {
  'enum.expenseMethod.CASH': 'Cash',
  'enum.expenseMethod.BANK_TRANSFER': 'Bank transfer',
  'enum.expenseMethod.CARD': 'Card',
  'enum.expenseFrequency.MONTHLY': 'Monthly',
  'enum.expenseFrequency.YEARLY': 'Yearly',

  'expenses.title': 'Expenses',
  'expenses.description': 'What the gym spends: log each expense with its receipt, set up the ones that repeat, and keep the categories.',
  'expenses.tab.expenses': 'Expenses',
  'expenses.tab.recurring': 'Recurring',
  'expenses.tab.categories': 'Categories',
  'expenses.log': 'Log expense',
  'expenses.logDescription': 'Record money the gym has spent. Receipts can be attached now or later.',
  'expenses.logSubmit': 'Log expense',
  'expenses.logged': 'Expense logged',
  'expenses.updated': 'Expense updated',
  'expenses.voided': 'Expense voided',
  'expenses.edit': 'Edit expense',
  'expenses.void': 'Void',
  'expenses.voidTitle': 'Void this expense?',
  'expenses.voidDescription': 'It stays in the list with who voided it and why, and stops counting in every report and in profit.',
  'expenses.voidPlaceholder': 'For example, entered twice',
  'expenses.voidedNotice': 'Voided by {name}, {date}',
  'expenses.voidReason': 'Reason: {reason}',
  'expenses.lockedNotice': 'This expense’s month is closed, so it cannot change, be voided or take receipts. An owner or admin can reopen the month.',
  'expenses.badge.voided': 'Voided',
  'expenses.badge.drawer': 'From the drawer',
  'expenses.badge.recurring': 'Recurring',
  'expenses.badge.locked': 'Locked',

  'expenses.searchPlaceholder': 'Search by supplier or note',
  'expenses.anyCategory': 'Any category',
  'expenses.anyBranch': 'Any branch',
  'expenses.anyMethod': 'Any method',
  'expenses.status.ALL': 'All',
  'expenses.status.ACTIVE': 'Active',
  'expenses.status.VOIDED': 'Voided',
  'expenses.clearFilters': 'Clear filters',
  'expenses.archivedName': '{name} (archived)',
  'expenses.totalSpent': 'Total spent',
  'expenses.totalSpentHint': 'Voided expenses are left out',
  'expenses.count': 'Expenses',
  'expenses.voidedCount': 'Voided',
  'expenses.empty': 'No expenses yet',
  'expenses.emptyHint': 'Log the first expense, or set up the ones that repeat every month.',
  'expenses.noMatch': 'No expenses match',
  'expenses.noMatchHint': 'Try another period or clear the filters.',

  'expenses.category': 'Category',
  'expenses.chooseCategory': 'Choose a category',
  'expenses.branch': 'Branch',
  'expenses.wholeGym': 'Whole gym',
  'expenses.supplier': 'Supplier',
  'expenses.loggedBy': 'Logged by',
  'expenses.loggedOn': 'Logged on',
  'expenses.postedAutomatically': 'Posted automatically',
  'expenses.recurringPeriod': 'Recurring period',
  'expenses.fromDrawer': 'Paid from the desk drawer',
  'expenses.fromDrawerHint': 'Cash taken from this branch’s open drawer today. The shift will expect that much less cash.',
  'expenses.dateFixed': 'Paid from the drawer, so dated today.',
  'expenses.drawerFixed': 'Paid from the drawer, so its date, method and branch cannot change.',

  'expenses.error.amount': 'Enter an amount above zero',
  'expenses.error.category': 'Choose a category',
  'expenses.error.date': 'Choose a date',
  'expenses.error.future': 'An expense is dated the day it was spent, not later',
  'expenses.error.day': 'Enter a day from 1 to 31',
  'expenses.error.endsBeforeStart': 'It cannot end before it starts',
  'expenses.error.branchNotAllowed': 'You keep the books of your own branches only; choose one of them.',

  'expenses.receipts': 'Receipts',
  'expenses.receipt.hint': 'PDF, JPEG, PNG or WebP, up to 10 MB each, at most {max}.',
  'expenses.receipt.attach': 'Attach files',
  'expenses.receipt.add': 'Add receipt',
  'expenses.receipt.added': 'Receipt added',
  'expenses.receipt.removed': 'Receipt removed',
  'expenses.receipt.remove': 'Remove',
  'expenses.receipt.open': 'Open the receipt',
  'expenses.receipt.none': 'No receipts attached.',
  'expenses.receipt.removeFile': 'Remove {name}',
  'expenses.receipt.tooLarge': 'A file is larger than 10 MB and was left out',
  'expenses.receipt.failedAfterSave': 'Saved, but a receipt did not upload',
  'expenses.receiptCount.one': '{count} receipt',
  'expenses.receiptCount.other': '{count} receipts',

  'expenses.categories.add': 'Add category',
  'expenses.categories.added': 'Category added',
  'expenses.categories.renamed': 'Category renamed',
  'expenses.categories.archived': 'Category archived',
  'expenses.categories.restored': 'Category restored',
  'expenses.categories.archive': 'Archive',
  'expenses.categories.restore': 'Restore',
  'expenses.categories.rename': 'Rename',
  'expenses.categories.renameTitle': 'Rename category',
  'expenses.categories.showArchived': 'Show archived',
  'expenses.categories.archivedBadge': 'Archived',
  'expenses.categories.empty': 'No categories yet',
  'expenses.categories.nameEnglish': 'English name',
  'expenses.categories.nameGeorgian': 'Georgian name',
  'expenses.categories.georgianHint': 'Shown to people using the app in Georgian; the English name is used when this is empty.',
  'expenses.categories.nameRequired': 'Enter the English name',
  'expenses.categories.dialogDescription': 'Archived categories leave the pickers but stay on the expenses they were used for.',

  'expenses.recurring.intro': 'Expenses that repeat on a fixed day, such as rent or software. Bulk posts each one on its day; what it already posted stays as it is.',
  'expenses.recurring.add': 'Add recurring expense',
  'expenses.recurring.added': 'Recurring expense added',
  'expenses.recurring.updated': 'Recurring expense updated',
  'expenses.recurring.switchedOn': 'Switched on',
  'expenses.recurring.switchedOff': 'Switched off',
  'expenses.recurring.empty': 'No recurring expenses',
  'expenses.recurring.emptyHint': 'Add rent, licences and other regular costs once, and they post themselves.',
  'expenses.recurring.schedule': 'Schedule',
  'expenses.recurring.next': 'Next posting',
  'expenses.recurring.nextOn': 'Next: {date}',
  'expenses.recurring.lastPosted': 'Last posted',
  'expenses.recurring.neverPosted': 'Not posted yet',
  'expenses.recurring.posted.one': '{count} posted',
  'expenses.recurring.posted.other': '{count} posted',
  'expenses.recurring.on': 'On',
  'expenses.recurring.off': 'Off',
  'expenses.recurring.ended': 'Ended',
  'expenses.recurring.editTitle': 'Edit recurring expense',
  'expenses.recurring.dialogDescription': 'Changes apply to the postings still to come. Expenses already posted stay as they are.',
  'expenses.recurring.frequency': 'Repeats',
  'expenses.recurring.dayOfMonth': 'Day of the month',
  'expenses.recurring.dayHint': 'Day 31 posts on the last day of months that are shorter.',
  'expenses.recurring.month': 'Month',
  'expenses.recurring.startsOn': 'Starts on',
  'expenses.recurring.startsHint': 'A start date in the past posts every missing period since then.',
  'expenses.recurring.endsOn': 'Ends on',
  'expenses.recurring.active': 'Active',
  'expenses.recurring.activeHint': 'Switch off to stop new postings; what it posted stays.',
  'expenses.schedule.monthly': 'Monthly on day {day}',
  'expenses.schedule.monthlyLast': 'Monthly on the last day',
  'expenses.schedule.yearly': 'Yearly on {day} {month}',
  'expenses.schedule.yearlyLast': 'Yearly on the last day of {month}',

  'profit.title': 'Profit',
  'profit.description': 'Income less expenses and payroll, by month and by branch.',
  'profit.preset.last12': 'Last 12 months',
  'profit.preset.thisYear': 'This year',
  'profit.preset.lastYear': 'Last year',
  'profit.preset.custom': 'Custom',
  'profit.fromMonth': 'First month',
  'profit.toMonth': 'Last month',
  'profit.place': 'Place',
  'profit.allPlaces': 'All places',
  'profit.rangeOrder': 'The first month is after the last.',
  'profit.rangeLong': 'Choose at most {max} months.',
  'profit.periodNote': 'From {from} to {to}. Amounts are in {currency}.',
  'profit.placeNote': 'Payroll, online payments and expenses of no branch are not split by branch, so they are not in a branch’s figures. Choose Whole gym to see them.',
  'profit.income': 'Income',
  'profit.expenses': 'Expenses',
  'profit.payroll': 'Payroll',
  'profit.profit': 'Profit',
  'profit.costs': 'Costs',
  'profit.incomeHint': 'Memberships and bar sales, less refunds',
  'profit.expensesHint': 'Voided expenses are left out',
  'profit.payrollHint': 'What the team costs the gym, with the employer’s pension',
  'profit.profitHint': 'Income less expenses and payroll',
  'profit.chartTitle': 'Income, costs and profit',
  'profit.chartDescription': 'Per month. Costs are expenses plus payroll.',
  'profit.byMonth': 'By month',
  'profit.memberships': 'Memberships',
  'profit.bar': 'Bar',
  'profit.closed': 'Month closed',
  'profit.draft': 'Draft',
  'profit.byPlace': 'By place',
  'profit.byPlaceDescription': 'Each branch and the whole gym over the period. The whole gym holds online payments, expenses of no branch and payroll.',

  'reports.dataset.expenses': 'Expenses',
  'reports.grouping.category': 'Category',
  'reports.measure.spent': 'Spent',
  'reports.measure.expenses': 'Expenses',
  'reports.measure.averageExpense': 'Average expense',
  'reports.builtIn.expensesByCategory': 'Expenses by category per month',

  'admin.apiError.MONTH_CLOSED': 'This month is closed. An owner or admin has to reopen it first.',
  'admin.apiError.EXPENSE_VOIDED': 'A voided expense can no longer change.',
  'admin.apiError.EXPENSE_FROM_DRAWER': 'Cash paid from the drawer keeps its date, method and branch.',
  'admin.apiError.DRAWER_SHIFT_CLOSED': 'The drawer this was paid from has been counted. Void the payout and record it again.',
  'admin.apiError.NO_OPEN_SHIFT': 'Open the cash drawer at this branch before paying from it.',
  'admin.apiError.EXPENSE_IN_FUTURE': 'An expense is recorded once the money is spent. A recurring expense posts the future ones on their day.',
  'admin.apiError.CATEGORY_ARCHIVED': 'This category is archived. Choose another or bring it back first.',
  'admin.apiError.DRAWER_NEEDS_CASH': 'Only cash comes out of the drawer.',
  'admin.apiError.DRAWER_EXPENSE_TODAY': 'Cash paid from the drawer is dated today.',
  'admin.apiError.TOO_MANY_RECEIPTS': 'An expense keeps at most {limit} receipts.',
  'admin.apiError.MONTH_REQUIRED': 'A yearly expense needs the month it falls in.',
};

export const ka: Record<keyof typeof en, string> = {
  'enum.expenseMethod.CASH': 'ნაღდი',
  'enum.expenseMethod.BANK_TRANSFER': 'საბანკო გადარიცხვა',
  'enum.expenseMethod.CARD': 'ბარათი',
  'enum.expenseFrequency.MONTHLY': 'ყოველთვიურად',
  'enum.expenseFrequency.YEARLY': 'ყოველწლიურად',

  'expenses.title': 'ხარჯები',
  'expenses.description': 'დარბაზის ხარჯები: აღრიცხეთ თითოეული ხარჯი ქვითრით, დააყენეთ განმეორებადი ხარჯები და მართეთ კატეგორიები.',
  'expenses.tab.expenses': 'ხარჯები',
  'expenses.tab.recurring': 'განმეორებადი',
  'expenses.tab.categories': 'კატეგორიები',
  'expenses.log': 'ხარჯის დამატება',
  'expenses.logDescription': 'აღრიცხეთ დარბაზის მიერ დახარჯული თანხა. ქვითრები ახლაც შეგიძლიათ მიამაგროთ და მოგვიანებითაც.',
  'expenses.logSubmit': 'ხარჯის დამატება',
  'expenses.logged': 'ხარჯი დაემატა',
  'expenses.updated': 'ხარჯი განახლდა',
  'expenses.voided': 'ხარჯი გაუქმდა',
  'expenses.edit': 'ხარჯის რედაქტირება',
  'expenses.void': 'გაუქმება',
  'expenses.voidTitle': 'გავაუქმოთ ეს ხარჯი?',
  'expenses.voidDescription': 'ხარჯი სიაში დარჩება მისი გამაუქმებლისა და მიზეზის მითითებით, მაგრამ აღარ ჩაითვლება არც ერთ ანგარიშსა და მოგებაში.',
  'expenses.voidPlaceholder': 'მაგალითად, ორჯერ იყო შეყვანილი',
  'expenses.voidedNotice': 'გააუქმა {name}, {date}',
  'expenses.voidReason': 'მიზეზი: {reason}',
  'expenses.lockedNotice': 'ამ ხარჯის თვე დახურულია, ამიტომ მისი შეცვლა, გაუქმება და ქვითრის დამატება შეუძლებელია. თვეს მფლობელი ან ადმინისტრატორი ხელახლა გახსნის.',
  'expenses.badge.voided': 'გაუქმებული',
  'expenses.badge.drawer': 'სალაროდან',
  'expenses.badge.recurring': 'განმეორებადი',
  'expenses.badge.locked': 'დაკეტილი',

  'expenses.searchPlaceholder': 'ძებნა მომწოდებლით ან შენიშვნით',
  'expenses.anyCategory': 'ნებისმიერი კატეგორია',
  'expenses.anyBranch': 'ნებისმიერი ფილიალი',
  'expenses.anyMethod': 'ნებისმიერი მეთოდი',
  'expenses.status.ALL': 'ყველა',
  'expenses.status.ACTIVE': 'მოქმედი',
  'expenses.status.VOIDED': 'გაუქმებული',
  'expenses.clearFilters': 'ფილტრების გასუფთავება',
  'expenses.archivedName': '{name} (დაარქივებული)',
  'expenses.totalSpent': 'სულ დახარჯული',
  'expenses.totalSpentHint': 'გაუქმებული ხარჯები არ ითვლება',
  'expenses.count': 'ხარჯები',
  'expenses.voidedCount': 'გაუქმებული',
  'expenses.empty': 'ხარჯები ჯერ არ არის',
  'expenses.emptyHint': 'დაამატეთ პირველი ხარჯი ან დააყენეთ ყოველთვიურად განმეორებადი ხარჯები.',
  'expenses.noMatch': 'შესაბამისი ხარჯი ვერ მოიძებნა',
  'expenses.noMatchHint': 'სცადეთ სხვა პერიოდი ან გაასუფთავეთ ფილტრები.',

  'expenses.category': 'კატეგორია',
  'expenses.chooseCategory': 'აირჩიეთ კატეგორია',
  'expenses.branch': 'ფილიალი',
  'expenses.wholeGym': 'მთელი დარბაზი',
  'expenses.supplier': 'მომწოდებელი',
  'expenses.loggedBy': 'დაამატა',
  'expenses.loggedOn': 'დამატების დრო',
  'expenses.postedAutomatically': 'დაემატა ავტომატურად',
  'expenses.recurringPeriod': 'განმეორების პერიოდი',
  'expenses.fromDrawer': 'გაცემულია მიმღების სალაროდან',
  'expenses.fromDrawerHint': 'დღეს ამ ფილიალის ღია სალაროდან აღებული ნაღდი ფული. ცვლა ამდენით ნაკლებ ნაღდ ფულს ელოდება.',
  'expenses.dateFixed': 'სალაროდან გაიცა, ამიტომ დღევანდელი თარიღით აღირიცხება.',
  'expenses.drawerFixed': 'ხარჯი სალაროდან გაიცა, ამიტომ მისი თარიღი, მეთოდი და ფილიალი ვერ შეიცვლება.',

  'expenses.error.amount': 'შეიყვანეთ ნულზე მეტი თანხა',
  'expenses.error.category': 'აირჩიეთ კატეგორია',
  'expenses.error.date': 'აირჩიეთ თარიღი',
  'expenses.error.future': 'ხარჯი იმ დღით აღირიცხება, როცა დაიხარჯა, და არა უფრო გვიანდელით',
  'expenses.error.day': 'შეიყვანეთ დღე 1-დან 31-მდე',
  'expenses.error.endsBeforeStart': 'დასრულების თარიღი დაწყების თარიღზე ადრე ვერ იქნება',
  'expenses.error.branchNotAllowed': 'თქვენ მხოლოდ საკუთარი ფილიალების ხარჯებს აღრიცხავთ; აირჩიეთ ერთ-ერთი მათგანი.',

  'expenses.receipts': 'ქვითრები',
  'expenses.receipt.hint': 'PDF, JPEG, PNG ან WebP, თითო ფაილი 10 მბ-მდე, მაქსიმუმ {max}.',
  'expenses.receipt.attach': 'ფაილების მიმაგრება',
  'expenses.receipt.add': 'ქვითრის დამატება',
  'expenses.receipt.added': 'ქვითარი დაემატა',
  'expenses.receipt.removed': 'ქვითარი წაიშალა',
  'expenses.receipt.remove': 'წაშლა',
  'expenses.receipt.open': 'ქვითრის გახსნა',
  'expenses.receipt.none': 'ქვითარი მიმაგრებული არ არის.',
  'expenses.receipt.removeFile': 'ამოშლა: {name}',
  'expenses.receipt.tooLarge': 'ფაილი 10 მბ-ზე დიდია და არ დაემატა',
  'expenses.receipt.failedAfterSave': 'შენახულია, მაგრამ ქვითარი ვერ აიტვირთა',
  'expenses.receiptCount.one': '{count} ქვითარი',
  'expenses.receiptCount.other': '{count} ქვითარი',

  'expenses.categories.add': 'კატეგორიის დამატება',
  'expenses.categories.added': 'კატეგორია დაემატა',
  'expenses.categories.renamed': 'კატეგორიის სახელი შეიცვალა',
  'expenses.categories.archived': 'კატეგორია დაარქივდა',
  'expenses.categories.restored': 'კატეგორია აღდგა',
  'expenses.categories.archive': 'დაარქივება',
  'expenses.categories.restore': 'აღდგენა',
  'expenses.categories.rename': 'სახელის შეცვლა',
  'expenses.categories.renameTitle': 'კატეგორიის სახელის შეცვლა',
  'expenses.categories.showArchived': 'დაარქივებულების ჩვენება',
  'expenses.categories.archivedBadge': 'დაარქივებული',
  'expenses.categories.empty': 'კატეგორიები ჯერ არ არის',
  'expenses.categories.nameEnglish': 'სახელი ინგლისურად',
  'expenses.categories.nameGeorgian': 'სახელი ქართულად',
  'expenses.categories.georgianHint': 'ქართულად მომუშავე თანამშრომლებს ეს სახელი გამოუჩნდებათ; თუ ცარიელია, ინგლისური სახელი გამოჩნდება.',
  'expenses.categories.nameRequired': 'შეიყვანეთ სახელი ინგლისურად',
  'expenses.categories.dialogDescription': 'დაარქივებული კატეგორია ასარჩევ სიებში აღარ ჩანს, მაგრამ იმ ხარჯებზე რჩება, რომლებზეც გამოიყენეს.',

  'expenses.recurring.intro': 'ფიქსირებულ დღეს განმეორებადი ხარჯები, მაგალითად, ქირა ან პროგრამები. Bulk თითოეულს მის დღეს დაამატებს; უკვე დამატებული ხარჯები უცვლელი რჩება.',
  'expenses.recurring.add': 'განმეორებადი ხარჯის დამატება',
  'expenses.recurring.added': 'განმეორებადი ხარჯი დაემატა',
  'expenses.recurring.updated': 'განმეორებადი ხარჯი განახლდა',
  'expenses.recurring.switchedOn': 'ჩაირთო',
  'expenses.recurring.switchedOff': 'გამოირთო',
  'expenses.recurring.empty': 'განმეორებადი ხარჯები არ არის',
  'expenses.recurring.emptyHint': 'დაამატეთ ქირა, ლიცენზიები და სხვა რეგულარული ხარჯები ერთხელ და ისინი თავისით დაემატება.',
  'expenses.recurring.schedule': 'განრიგი',
  'expenses.recurring.next': 'შემდეგი დამატება',
  'expenses.recurring.nextOn': 'შემდეგი: {date}',
  'expenses.recurring.lastPosted': 'ბოლოს დაემატა',
  'expenses.recurring.neverPosted': 'ჯერ არ დამატებულა',
  'expenses.recurring.posted.one': '{count} დამატებული',
  'expenses.recurring.posted.other': '{count} დამატებული',
  'expenses.recurring.on': 'ჩართული',
  'expenses.recurring.off': 'გამორთული',
  'expenses.recurring.ended': 'დასრულდა',
  'expenses.recurring.editTitle': 'განმეორებადი ხარჯის რედაქტირება',
  'expenses.recurring.dialogDescription': 'ცვლილებები შეეხება მხოლოდ მომავალ დამატებებს. უკვე დამატებული ხარჯები უცვლელი რჩება.',
  'expenses.recurring.frequency': 'განმეორება',
  'expenses.recurring.dayOfMonth': 'თვის დღე',
  'expenses.recurring.dayHint': 'დღე 31 მოკლე თვეებში თვის ბოლო დღეს დაემატება.',
  'expenses.recurring.month': 'თვე',
  'expenses.recurring.startsOn': 'იწყება',
  'expenses.recurring.startsHint': 'წარსულში არჩეული საწყისი თარიღის შემთხვევაში იმ დღიდან დღემდე ყველა გამოტოვებული პერიოდი დაემატება.',
  'expenses.recurring.endsOn': 'მთავრდება',
  'expenses.recurring.active': 'აქტიური',
  'expenses.recurring.activeHint': 'გამორთვა ახალ დამატებებს შეაჩერებს; უკვე დამატებული ხარჯები დარჩება.',
  'expenses.schedule.monthly': 'ყოველთვიურად, თვის {day} რიცხვში',
  'expenses.schedule.monthlyLast': 'ყოველთვიურად, თვის ბოლო დღეს',
  'expenses.schedule.yearly': 'ყოველწლიურად: {day} {month}',
  'expenses.schedule.yearlyLast': 'ყოველწლიურად: {month}, თვის ბოლო დღე',

  'profit.title': 'მოგება',
  'profit.description': 'შემოსავალს გამოკლებული ხარჯები და ხელფასები, თვეებისა და ფილიალების მიხედვით.',
  'profit.preset.last12': 'ბოლო 12 თვე',
  'profit.preset.thisYear': 'ეს წელი',
  'profit.preset.lastYear': 'გასული წელი',
  'profit.preset.custom': 'არჩევით',
  'profit.fromMonth': 'პირველი თვე',
  'profit.toMonth': 'ბოლო თვე',
  'profit.place': 'ადგილი',
  'profit.allPlaces': 'ყველა ადგილი',
  'profit.rangeOrder': 'პირველი თვე ბოლო თვის შემდეგია.',
  'profit.rangeLong': 'აირჩიეთ მაქსიმუმ {max} თვე.',
  'profit.periodNote': 'პერიოდი: {from} – {to}. თანხები მითითებულია ვალუტაში: {currency}.',
  'profit.placeNote': 'ხელფასები, ონლაინ გადახდები და ფილიალზე მიუბმელი ხარჯები ფილიალებს შორის არ იყოფა, ამიტომ ფილიალის მაჩვენებლებში არ შედის. მათ სანახავად აირჩიეთ „მთელი დარბაზი“.',
  'profit.income': 'შემოსავალი',
  'profit.expenses': 'ხარჯები',
  'profit.payroll': 'ხელფასები',
  'profit.profit': 'მოგება',
  'profit.costs': 'დანახარჯები',
  'profit.incomeHint': 'აბონემენტები და ბარის გაყიდვები, დაბრუნებების გამოკლებით',
  'profit.expensesHint': 'გაუქმებული ხარჯები არ ითვლება',
  'profit.payrollHint': 'რა უჯდება დარბაზს გუნდი, დამსაქმებლის საპენსიო შენატანის ჩათვლით',
  'profit.profitHint': 'შემოსავალს გამოკლებული ხარჯები და ხელფასები',
  'profit.chartTitle': 'შემოსავალი, დანახარჯები და მოგება',
  'profit.chartDescription': 'თვეების მიხედვით. დანახარჯები ხარჯებისა და ხელფასების ჯამია.',
  'profit.byMonth': 'თვეების მიხედვით',
  'profit.memberships': 'აბონემენტები',
  'profit.bar': 'ბარი',
  'profit.closed': 'თვე დახურულია',
  'profit.draft': 'მონახაზი',
  'profit.byPlace': 'ადგილების მიხედვით',
  'profit.byPlaceDescription': 'პერიოდის განმავლობაში თითოეული ფილიალი და მთელი დარბაზი. „მთელი დარბაზი“ მოიცავს ონლაინ გადახდებს, ფილიალზე მიუბმელ ხარჯებსა და ხელფასებს.',

  'reports.dataset.expenses': 'ხარჯები',
  'reports.grouping.category': 'კატეგორია',
  'reports.measure.spent': 'დახარჯული',
  'reports.measure.expenses': 'ხარჯები',
  'reports.measure.averageExpense': 'საშუალო ხარჯი',
  'reports.builtIn.expensesByCategory': 'ხარჯები კატეგორიებისა და თვეების მიხედვით',

  'admin.apiError.MONTH_CLOSED': 'ეს თვე დახურულია. ჯერ მფლობელმა ან ადმინისტრატორმა უნდა გახსნას.',
  'admin.apiError.EXPENSE_VOIDED': 'გაუქმებული ხარჯი აღარ იცვლება.',
  'admin.apiError.EXPENSE_FROM_DRAWER': 'სალაროდან გაცემულ ხარჯს თარიღი, მეთოდი და ფილიალი უცვლელი რჩება.',
  'admin.apiError.DRAWER_SHIFT_CLOSED': 'სალარო, საიდანაც ეს თანხა გაიცა, უკვე დათვლილია. გააუქმეთ გაცემა და ხელახლა დაამატეთ.',
  'admin.apiError.NO_OPEN_SHIFT': 'სალაროდან თანხის გაცემამდე გახსენით ამ ფილიალის სალაროს ცვლა.',
  'admin.apiError.EXPENSE_IN_FUTURE': 'ხარჯი აღირიცხება მას შემდეგ, რაც თანხა დაიხარჯა. მომავალი ხარჯები განმეორებად ხარჯად დაემატება თავის დღეს.',
  'admin.apiError.CATEGORY_ARCHIVED': 'ეს კატეგორია დაარქივებულია. აირჩიეთ სხვა ან ჯერ აღადგინეთ.',
  'admin.apiError.DRAWER_NEEDS_CASH': 'სალაროდან მხოლოდ ნაღდი ფული გაიცემა.',
  'admin.apiError.DRAWER_EXPENSE_TODAY': 'სალაროდან გაცემული ნაღდი ფული დღევანდელი თარიღით აღირიცხება.',
  'admin.apiError.TOO_MANY_RECEIPTS': 'ერთ ხარჯზე მაქსიმუმ {limit} ქვითარი შეიძლება.',
  'admin.apiError.MONTH_REQUIRED': 'ყოველწლიური ხარჯისთვის საჭიროა თვის მითითება.',
};
